import React from "react";
import { UILeg } from "@flights/types";

import { createTrackingUtils } from "..";
import useUserAgent from "../../../hooks/useUserAgent";
import { NEW_CIRIUM_CHECKIN_LINKS } from "@flights/constants";

export const trackCheckInLinks = createTrackingUtils({
  defaultStage: 1,
  name: "flights_pb_universal_checkin_links_cirium",
  stages: {
    AFFECTED_USERS: 1,
    CHECK_IN_PAGE_WITH_NEW_AIRLINE_LINKS: 2,
    CHECK_IN_PAGE_WITH_NEW_AIRLINE_LINKS_DESKTOP: 3,
    CHECK_IN_PAGE_WITH_NEW_AIRLINE_LINKS_MDOT: 4,
    CHECK_IN_PAGE_WITH_NEW_AIRLINE_LINKS_ISO: 5,
    CHECK_IN_PAGE_WITH_NEW_AIRLINE_LINKS_ANDROID: 6,
    CHECK_IN_PAGE_WITH_NEW_WIZZ_AIR_MALTA_LINK: 7
  },
  goals: {
    FLIGHTS_WEB_APPS_HC_CLICK: 1,
    CHECKIN_VIA_AIRLINE_WEBSITE_CLICK: 2
  },
  goalsWithValue: []
});

export const useTrackCheckInLinks = (legsWithOpenedCheckIn: UILeg[]) => {
  const { isMobile } = useUserAgent();
  React.useEffect(() => {
    const hasCarrierInTheNewCiriumCheckInLinksArray = legsWithOpenedCheckIn.some(
      (leg) =>
        !!leg.flightInfo.carrierInfo?.marketingCarrier &&
        NEW_CIRIUM_CHECKIN_LINKS.includes(leg.flightInfo.carrierInfo.marketingCarrier)
    );

    const hasW4Carrier = legsWithOpenedCheckIn.some(
      (leg) => !!leg.flightInfo.carrierInfo?.marketingCarrier && leg.flightInfo.carrierInfo.marketingCarrier === "W4"
    );

    if (hasW4Carrier) {
      trackCheckInLinks.stages.CHECK_IN_PAGE_WITH_NEW_WIZZ_AIR_MALTA_LINK();
    }

    if (hasCarrierInTheNewCiriumCheckInLinksArray) {
      trackCheckInLinks.stages.CHECK_IN_PAGE_WITH_NEW_AIRLINE_LINKS();

      isMobile
        ? trackCheckInLinks.stages.CHECK_IN_PAGE_WITH_NEW_AIRLINE_LINKS_MDOT()
        : trackCheckInLinks.stages.CHECK_IN_PAGE_WITH_NEW_AIRLINE_LINKS_DESKTOP();
    }
  }, [isMobile, legsWithOpenedCheckIn]);
};
